module.exports = __webpack_public_path__ + "images/emoji/wind_chime.8da57d5cc09d5258299e.png";